// Helper functions for generating Impact by Impact Pathways chart data

import { getFilteredReportData } from '../helpers/filterHelpers'
import {
  HEALTH_IMPACT,
  WELLBEING_IMPACT,
  INDIRECT_FINANCIAL_HEALTH_IMPACT,
  INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT
} from '../fields'
import { impactColors } from '../SocialValueByStakeholders/fields'

const impactTypeLabels = {
  [INDIRECT_FINANCIAL_HEALTH_IMPACT]: 'Indirect financial impact via health',
  [INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT]: 'Indirect financial impact via human capital',
  [WELLBEING_IMPACT]: 'Wellbeing impact',
  [HEALTH_IMPACT]: 'Health impact'
}

// Generate chart data for impact pathways
const generateImpactPathwaysChartData = impactPathwaysData => {
  if (impactPathwaysData) {
    const labels = Object.values(impactTypeLabels)
    const data = [
      impactPathwaysData[INDIRECT_FINANCIAL_HEALTH_IMPACT] || 0,
      impactPathwaysData[INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT] || 0,
      impactPathwaysData[WELLBEING_IMPACT] || 0,
      impactPathwaysData[HEALTH_IMPACT] || 0
    ]

    return {
      labels: labels,
      datasets: [
        {
          label: 'Impact by Impact Pathways',
          data: data,
          backgroundColor: [
            impactColors[INDIRECT_FINANCIAL_HEALTH_IMPACT],
            impactColors[INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT],
            impactColors[WELLBEING_IMPACT],
            impactColors[HEALTH_IMPACT]
          ],
          spacing: 1,
          borderRadius: 8
        }
      ]
    }
  } else {
    return {
      labels: [],
      datasets: []
    }
  }
}

// Main function to generate chart data
export const generateImpactPathwaysData = ({ selectedRegion, selectedStakeholder, report }) => {
  // Note: fieldName is null because we need the whole object with all impact pathway fields
  const impactPathwaysData = getFilteredReportData({
    report,
    selectedRegion,
    selectedStakeholder,
    fieldName: null
  })
  return generateImpactPathwaysChartData(impactPathwaysData)
}
